import { GET_AVAILABLE_COUNTERS, SET_USER_COUNTER } from '../actions/actionTypes';

const initialState: any = 0;

export const userCounterReducer = (state: any = initialState, action: any) => {

  switch (action.type) {

    case SET_USER_COUNTER:
      return action.data;
    default:
      return state;
  }
};